import {useState, useCallback} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createSCAPIFetch} from '../utills/customFetch'

const useConfirmationMail = () => {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const {app: appConfig} = getConfig()

    const sendConfirmationMail = useCallback(
        async (scapiAccessToken, email) => {
            if (!scapiAccessToken || !email) return

            setLoading(true)
            setError(null)

            const slotParams = `c_customerEmail=${email}`

            const args = [
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${scapiAccessToken}`
                    }
                }
            ]

            try {
                const customFetch = createSCAPIFetch(
                    appConfig,
                    'custom/braze-reset-password',
                    slotParams
                )
                const result = await customFetch('resetPasswordBraze', 'GET', args)
                const htmlRes = await result.json()
                setResponse(htmlRes)
                return htmlRes
            } catch (err) {
                setError(err.message || 'An unexpected error occurred')
                throw err
            } finally {
                setLoading(false)
            }
        },
        [appConfig]
    )

    return {sendConfirmationMail, response, loading, error}
}

export default useConfirmationMail
